import {useAuth} from 'attendee/Auth/Providers/AuthProvider'
import {useI18n} from 'i18n/I18nContext'
import useProductPayment from 'attendee/Billing/Payments/useProductPayment'
import {useAttendeeBilling} from 'attendee/Billing/Providers/AttendeeBillingProvider'
import {useFormik} from 'formik'
import {Product} from 'organization/Event/Products/EventProductsProvider'
import React from 'react'

export default function AttendeeInfoModal(props: {
  show: boolean
  toggle: () => void
  product: Product
}) {
  const {t} = useI18n()
  const {show, toggle, product} = props

  const {payPayment} = useAttendeeBilling()
  const {payment} = useProductPayment(product?.id || null)
  const {user} = useAuth()

  const {handleSubmit, handleBlur, handleChange, values} = useFormik({
    initialValues: {
      phone_number: user?.delivery_phone || '',
      name: user?.delivery_names || '',
      address: user?.delivery_address || '',
    },
    enableReinitialize: true,
    onSubmit: async (values: {
      phone_number: string
      name: string
      address: string
    }) => {
      payPayment(payment(values))
      toggle()
    },
  })

  if (!product) return null

  return (
    <>
      <div
        onClick={toggle}
        className={`offcanvas__overlay ${show ? 'overlay-open' : ''}`}
      ></div>
      <section className={`speaker__popup-area ${show ? 'open' : ''}`}>
        <div className="popup__wrapper">
          <div className="popup__title-wrapper">
            <h3 className="popup__title">
              {t('templateEditor.deliveryDetails')}
            </h3>
          </div>
          <div className="popup__input-wrapper">
            <form onSubmit={handleSubmit}>
              {product.need_phone && (
                <div className="singel__input-field mb-15">
                  <label className="input__field-email">
                    {t('templateEditor.yourPhone')} <br />
                  </label>
                  <input
                    type="text"
                    name="phone_number"
                    defaultValue={values.phone_number}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required
                  />
                </div>
              )}

              {product.need_name && (
                <div className="singel__input-field mb-15">
                  <label className="input__field-email">
                    {t('templateEditor.yourNames')} <br />
                  </label>
                  <input
                    type="text"
                    name="name"
                    defaultValue={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required
                  />
                </div>
              )}

              {product.need_address && (
                <div className="singel__input-field mb-15">
                  <label className="input__field-email">
                    {t('templateEditor.deliveryAddress')} <br />
                  </label>
                  <input
                    type="text"
                    name="address"
                    defaultValue={values.address}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required
                  />
                </div>
              )}

              <button type="submit" className={'input__btn w-100'}>
                {t('templateEditor.next')}
              </button>
            </form>
          </div>
        </div>
      </section>
    </>
  )
}
